let sellerOptions = [<option value='all'>All</option>, <option value='sellerAssigned'>Assigned to me</option>];

export default sellerOptions;
